/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

export const INTERVENTION_STATUS_ENDED = 'ended'
export const INTERVENTION_STATUS_ONGOING = 'ongoing'
export const INTERVENTION_STATUS_TO_COME_UP = 'to_come_up'
export const INTERVENTION_STATUS_UNKNOWN = 'unknown'

const InterventionStatusCodes = [
  INTERVENTION_STATUS_ENDED,
  INTERVENTION_STATUS_ONGOING,
  INTERVENTION_STATUS_TO_COME_UP,
  INTERVENTION_STATUS_UNKNOWN
]

export default InterventionStatusCodes
